import { JsonProperty } from 'js-ts-mapper';

export class Answer {

    @JsonProperty('id')
    id?:          string;

    @JsonProperty('description')
    description?: string;

    @JsonProperty('weight')
    weight?:      number;

    @JsonProperty('value')
    value?: string;

}
